import { useEffect, useState } from 'react';
import { message, Table, Button, Card, Space, Row, Col, Collapse, Input, Typography, Divider } from 'antd';
import { notifyMessages, tablePageSize } from '../../utils/constants';
import { PageHeader } from '../../components/common/pageHeader';
import { PlusOutlined } from '@ant-design/icons';
import DivisionsServices from '../../services/divisionsServices';
import UpdateDivision from './updateDivision';
import NewDivision from './newDivision';
import "./divisions.scss";
const { Link } = Typography;

const initialFilters = {
    divisionName: ""
}

const DivisionsList = () => {
    const [filters, setFilters] = useState(initialFilters);
    const [divisions, setDivisions] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [openCreateDrawer, setOpenCreateDrawer] = useState(false);
    const [openUpdateDrawer, setOpenUpdateDrawer] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);

    useEffect(() => {
        getDivisions(initialFilters);
    }, []);

    const showDrawer = (drawerName, record) => {
        if (drawerName === "create") setOpenCreateDrawer(true);
        if (drawerName === "update") {
            setOpenUpdateDrawer(true);
            setSelectedRecord(record);
        }
    };

    const onCloseDrawer = (drawerName) => {
        if (drawerName === "create") setOpenCreateDrawer(false);
        if (drawerName === "update") setOpenUpdateDrawer(false);
    };

    const getDivisions = async (appliedFilters) => {
        setLoadingData(true);
        try {
            const respData = await DivisionsServices.getDivisions(appliedFilters);
            if (respData.success) {
                let result = respData.responseObject.value;
                setDivisions(result.divisionListDTO);
                setLoadingData(false);
            } else {
                message.error(notifyMessages.errorAccured);
                setLoadingData(false);
            }
        } catch (error) {
            message.error(notifyMessages.errorAccured);
            setLoadingData(false);
        }
    };

    const columns = [
        {
            title: 'Divisione',
            dataIndex: 'name',
            key: 'name',
        },
        {
            key: "action1",
            width: "50px",
            render: (_, record) => (
                <Space>
                    <Link style={{ color: "#0f4d65" }} onClick={() => showDrawer("update", record)}>Apri</Link >
                </Space>
            )
        }
    ];

    const onFilter = () => {
        getDivisions(filters);
    }

    const onClearFilters = () => {
        setFilters(initialFilters);
        getDivisions(initialFilters);
    }

    const handelFilterChange = (name, value) => {
        setFilters((prev) => ({ ...prev, [name]: value }));
    }

    const panelItems = [
        {
            key: '1',
            label: 'Filtra',
            children: (
                <>
                    <Row gutter={{ lg: 24 }}>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }}>
                            <Space direction='vertical'>
                                <span>Nome</span>
                                <Input value={filters.divisionName} onChange={(e) => handelFilterChange("divisionName", e.target.value)} />
                            </Space>
                        </Col>
                    </Row>
                    <Divider />
                    <Row gutter={{ lg: 24 }}>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                            <Button type="primary" style={{ marginRight: 10 }} onClick={() => onFilter()}> Filtra </Button>
                            <Button onClick={() => onClearFilters()}> Rimuovi  </Button>
                        </Col>
                    </Row>
                </>
            )
        }
    ]

    return (
        <div className="divisionsContainer">
            <NewDivision open={openCreateDrawer} onClose={() => onCloseDrawer("create")} getDivisions={() => getDivisions(initialFilters)} />

            {selectedRecord && (
                <UpdateDivision open={openUpdateDrawer} onClose={() => onCloseDrawer("update")} getDivisions={() => getDivisions(initialFilters)} recordData={selectedRecord} />
            )}

            <PageHeader title="Divisioni" />

            <Row gutter={{ lg: 24 }} className="usersContainer filters-collapse">
                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                    <Collapse size='small' className='filterPanel' items={panelItems} defaultActiveKey={['1']} />
                </Col>
            </Row>

            <Card extra={<Button type="primary" onClick={() => showDrawer("create")} icon={<PlusOutlined />}>Aggiungi</Button>}>
                <Table
                    className='customTableRows'
                    rowClassName={(_, index) =>
                        index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
                    }
                    dataSource={divisions}
                    columns={columns}
                    rowKey={obj => obj.id}
                    pagination={{
                        pageSize: tablePageSize
                    }}
                    loading={loadingData}
                    size='small'
                    bordered
                />
            </Card>
        </div>
    );
};

export default DivisionsList;
